import { gql } from "@apollo/client";

export const UPDATE_PROTECTION_PLAN = gql`
  mutation updateProtectionPlan($protectionPlan: UpdateProtectionPlanInput!) {
    updateProtectionPlan(protectionPlan: $protectionPlan) {
      id
      name
      description
      excess
      code
    }
  }
`;
